import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

function readStoredUser() {
  try {
    const t = localStorage.getItem("aura_token");
    const u = localStorage.getItem("aura_user");
    if (t && u) return JSON.parse(u);
  } catch (e) {}
  return null;
}

export function AuthProvider({ children }) {
  const stored = readStoredUser();
  const [user, setUser] = useState(stored || (localStorage.getItem("aura_token") ? null : false));
  const [checking, setChecking] = useState(!stored && !!localStorage.getItem("aura_token"));

  const persist = (data) => {
    if (data?.access_token) localStorage.setItem("aura_token", data.access_token);
    localStorage.setItem("aura_user", JSON.stringify(data));
    setUser(data);
  };

  useEffect(() => {
    const token = localStorage.getItem("aura_token");
    if (!token) { setUser(false); setChecking(false); return; }
    // background revalidation; never force-logout on transient failure
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("aura_user", JSON.stringify(r.data)); })
      .catch(() => {})
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    persist(data);
    return data;
  };
  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    persist(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("aura_token");
    localStorage.removeItem("aura_user");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, checking, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
